import React, { Component } from 'react';
import * as yup from 'yup';

import Modal, {
  ModalAction,
  ModalBody,
  ModalButton,
  ModalHeader,
} from '../../../components/Modal/Modal';
import { trans } from '../../../localization';
import InputFormWrapper from '../../../components/Common/InputFormWrapper';
import NowInput from '../../../components/Common/NowInput';

class ChangePasswordModal extends Component {
  state = {
    currentPassword: '',
    newPassword: '',
    reNewPassword: '',
    isSubmit: false,
  };

  handleChangeInput = (stateObj) => {
    this.setState({
      ...stateObj,
    });
  };

  handleChangePassword = () => {
    const {
      setGeneralError,
      changePassword,
      openChangePasswordModal,
      openSettingModal,
    } = this.props;

    this.setState({
      isSubmit: true,
    });

    function validate(reqParam) {
      const requiredMessage = trans('set_required_fill_information');
      const schema = yup.object().shape({
        currentPassword: yup.string().required(requiredMessage),
        newPassword: yup.string().required(requiredMessage),
        reNewPassword: yup
          .string()
          .required(requiredMessage)
          .oneOf(
            [yup.ref('newPassword'), null],
            trans('set_required_match_password'),
          ),
      });
      try {
        schema.validateSync(reqParam);
        return true;
      } catch (err) {
        setGeneralError(err.message);
        return false;
      }
    }

    function genBody({ state }) {
      const { currentPassword, newPassword } = state;
      const reqParam = {
        currentPassword,
        newPassword,
      };
      return reqParam;
    }
    if (validate(this.state)) {
      const reqParam = genBody({ state: this.state });
      changePassword(reqParam).then((result) => {
        if (result) {
          openChangePasswordModal(false);
          openSettingModal(false);
        }
      });
    }
  };

  render() {
    const { isOpenDialog, openChangePasswordModal } = this.props;
    const {
      currentPassword,
      newPassword,
      reNewPassword,
      isSubmit,
    } = this.state;
    return (
      <React.Fragment>
        <Modal
          isOpen={isOpenDialog}
          onRequestClose={() => openChangePasswordModal(false)}
          width="500px"
        >
          <ModalHeader closeButton>{trans('set_change_password')}</ModalHeader>
          <ModalBody>
            <InputFormWrapper
              label={trans('set_current_password')}
              required
              width={5}
            >
              <NowInput
                value={currentPassword}
                type="password"
                onChange={evt =>
                  this.handleChangeInput({ currentPassword: evt.target.value })
                }
                required={isSubmit}
                placeholder={trans('set_current_password_holder')}
              />
            </InputFormWrapper>
            <InputFormWrapper
              label={trans('set_new_password')}
              required
              width={5}
            >
              <NowInput
                value={newPassword}
                type="password"
                onChange={evt =>
                  this.handleChangeInput({ newPassword: evt.target.value })
                }
                required={isSubmit}
                placeholder={trans('set_new_password_holder')}
              />
            </InputFormWrapper>
            <InputFormWrapper
              label={trans('set_renew_password')}
              required
              width={5}
            >
              <NowInput
                value={reNewPassword}
                type="password"
                onChange={evt =>
                  this.handleChangeInput({ reNewPassword: evt.target.value })
                }
                required={isSubmit}
                placeholder={trans('set_renew_password_holder')}
              />
            </InputFormWrapper>
          </ModalBody>
          <ModalAction>
            <ModalButton onClick={this.handleChangePassword}>
              {trans('set_change')}
            </ModalButton>
            <ModalButton
              type="cancel"
              onClick={() => openChangePasswordModal(false)}
            >
              {trans('common_close')}
            </ModalButton>
          </ModalAction>
        </Modal>
      </React.Fragment>
    );
  }
}

export default ChangePasswordModal;



// WEBPACK FOOTER //
// ./foody/src/pages/Setting/components/ChangePasswordModel.jsx